"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterForm = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const newsletter_hooks_1 = require("../../shared/newsletter.hooks");
const NewsletterButton_atom_1 = require("./NewsletterButton.atom");
const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,; =\s@"]+(\.[^<>()[\]\\.,; =\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};
const Form = styled_components_1.default.div `
	top: 90px;
	position: relative;
	width: 100%;
	padding: 0 24px;
	color: black;
	font-family: ${(p) => p.theme.fonts.default};

	.signup-title {
		text-align: center;
		margin: 0 0 16px;
	}

	.legal-notice,
	.privacy-link {
		color: #333;
		text-align: center;
		font-size: 13px;
	}

	.legal-notice {
		margin-bottom: 5px;
		font-style: italic;
	}

	.privacy-link {
		a {
			color: #333;
			transition: color 0.3s ${(p) => p.theme.easing};
			text-decoration: underline;
			&:hover {
				color: #000;
			}
		}
	}

	.sign-up-button {
		text-align: center;
		display: block;
		margin: 16px auto;
	}

	.sign-up-form-field {
		position: relative;
	}

	.email-label {
		padding-left: 10px;
		font-size: 12px;
		text-transform: uppercase;
		color: #a9aaaa;
		z-index: 1;
		top: 17px;
		font-weight: 300;
	}

	.input-field {
		display: block;
		width: 100%;
		padding: 8px 20px 10px 10px;
		margin: 0;
		height: 50px;
		border: 1px solid #ddd;
		border-radius: 1px;
		border-top-left-radius: 1px;
		border-top-right-radius: 1px;
		border-bottom-right-radius: 1px;
		border-bottom-left-radius: 1px;
		outline: none;
		font-size: 14px;
		font-weight: 400;
		text-align: left;
		background-color: #f2f2f2;
		color: #000;
	}

	.success-view {
		padding: 32px;
		font-size: 18px;
	}

	.errorMsg {
		padding-top: 10px;
		display: block;
		color: #f73131;
		font-size: 13.5px;
		margin: 0;
	}
`;
let emailDirty = false;
const NewsletterForm = ({ locale, email: accountEmail, newsLetterConfigs = {}, newsLetterReactConfig = {}, statusSubscribed = false, }) => {
    const { newsletterFormChildren, alreadySubscribed, isEmailReadOnly, beforeSubmit } = newsLetterReactConfig;
    const { btnTxt, titleMsg, loginRequired, successMsg } = newsLetterConfigs;
    const previouslySubscribed = alreadySubscribed || statusSubscribed;
    const [email, setEmail] = (0, react_1.useState)(accountEmail || "");
    const [emailValid, setEmailValid] = (0, react_1.useState)(validateEmail(accountEmail || ""));
    const getMessage = (0, epic_games_nav_shared_1.useLocalization)();
    const inputOnChange = (0, react_1.useCallback)((e) => {
        emailDirty = true;
        const target = e.target || {};
        const email = target.value || "";
        setEmail(email);
        setEmailValid(validateEmail(email));
    }, [setEmailValid, setEmail]);
    const { subscribe, subscribed, loading, error: errorMsg } = (0, newsletter_hooks_1.useNewsletterSubscribe)();
    const submit = (0, react_1.useCallback)(() => {
        if (loading)
            return;
        let request = { email, locale };
        let continueSubmit = true;
        if (beforeSubmit && typeof beforeSubmit === "function") {
            const beforeSubmitResponse = beforeSubmit(request);
            request = beforeSubmitResponse.request;
            continueSubmit = beforeSubmitResponse.continueSubmit;
        }
        if (continueSubmit) {
            subscribe(request);
        }
    }, [email, locale, loading, beforeSubmit, subscribe]);
    const invalid = !emailValid && emailDirty;
    const disabled = !email || invalid;
    return (react_1.default.createElement(Form, { className: "newsletter-form" }, previouslySubscribed || subscribed ? (react_1.default.createElement("div", { className: "success-view" }, successMsg)) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h3", { className: "signup-title" }, titleMsg),
        react_1.default.createElement("div", { className: `sign-up-form-field ${invalid ? "invalid" : ""}` },
            react_1.default.createElement("label", { id: "signUpEmailLabel", htmlFor: "signUpEmail", className: "email-label" },
                getMessage("epic.footer.newsletter.email.label") || "Email",
                " *"),
            react_1.default.createElement("input", { id: "signUpEmail", className: "input-field", value: email, onChange: inputOnChange, disabled: isEmailReadOnly || Boolean(loginRequired && email) }),
            invalid && (react_1.default.createElement("p", { className: "email errorMsg" }, getMessage("epic.footer.newsletter.error.invalid") || "Invalid email format"))),
        react_1.default.createElement("div", { className: "newsletter-children-wrap" }, newsletterFormChildren),
        errorMsg && react_1.default.createElement("p", { className: "errorMsg" }, errorMsg),
        react_1.default.createElement(NewsletterButton_atom_1.NewsletterButton, { id: "sign-up-button", className: `sign-up-button ${invalid ? "invalid" : ""}`, onClick: submit, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, disabled: disabled }, btnTxt || "Submit"),
        react_1.default.createElement("div", { className: "legal-notice" }, getMessage("epic.footer.newsletter.legal.notice")),
        react_1.default.createElement("div", { className: "privacy-link" },
            react_1.default.createElement("a", { href: `https://www.epicgames.com/${locale}/privacypolicy?lang=${locale}`, target: "_blank", onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, rel: "noreferrer" },
                react_1.default.createElement("span", null, getMessage("epic.footer.privacy_policy") || "Privacy policy")))))));
};
exports.NewsletterForm = NewsletterForm;
//# sourceMappingURL=NewsletterForm.molecule.js.map